const KEY = 'cp_utm';
const SESSION_KEY = 'cp_utm_session';
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid'];

const hasConsent = () => {
  try { return localStorage.getItem('cp_cookie_consent') === 'accepted'; } catch (e) { return false; }
};

// Avant consentement : conservation éphémère (sessionStorage, effacé à la fermeture de l'onglet).
// Après consentement : conservation 13 mois max (localStorage).
export function captureUTM() {
  try {
    const p = new URLSearchParams(window.location.search);
    const utm = {};
    UTM_KEYS.forEach(k => {
      if (p.get(k)) utm[k] = p.get(k);
    });
    if (Object.keys(utm).length) {
      utm.captured_at = new Date().toISOString();
      utm.landing_page = window.location.pathname;
      sessionStorage.setItem(SESSION_KEY, JSON.stringify(utm));
      if (hasConsent()) localStorage.setItem(KEY, JSON.stringify(utm));
    }
  } catch (e) { /* noop */ }
}

export function getUTM() {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY) || (hasConsent() ? localStorage.getItem(KEY) : null);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}
